<app-navbar></app-navbar>
<main [@appAnimation]="prepareRoute(outlet)">
    <router-outlet #outlet="outlet"></router-outlet>
</main>
<app-footer></app-footer>

